/* istanbul ignore file */
import {getDisplayCssVars} from '@wix/wixstores-client-storefront-common';
import {getShouldRenderVars} from './shouldRenderVars';
import type {CustomCssVarsFnParams} from '@wix/wixstores-client-storefront-common';
import {getInfoSectionLayoutCustomCssVars} from '../../../productPage/components/InfoSectionLayout/infoSectionLayout.cssVars';
import {getProductPageButtonContainerCustomCssVars} from '../../../productPage/components/ProductPageButtonsContainer/ProductPageButtonContainer.cssVars';
import {getProductOptionsCustomCssVars} from '../../../productPage/components/ProductOptions/ProductOptions.cssVars';
import {getResponsiveLayoutCustomCssVars} from '../../../productPage/components/Layouts/ResponsiveLayout/ResponsiveLayout.cssVars';

export const getCustomCssVars = (customCssVarsFnParams: CustomCssVarsFnParams) => {
  const {isRTL} = customCssVarsFnParams;

  return {
    imageGalleryPaginationDotsDirection: isRTL ? 'row-reverse' : 'row',
    ...getProductOptionsCustomCssVars(customCssVarsFnParams),
    ...getProductPageButtonContainerCustomCssVars(customCssVarsFnParams),
    ...getInfoSectionLayoutCustomCssVars(customCssVarsFnParams),
    ...getResponsiveLayoutCustomCssVars(customCssVarsFnParams),
  };
};

export const customCssVars = (customCssVarsFnParams: CustomCssVarsFnParams) => {
  const {styleParams, isMobile, isRTL} = customCssVarsFnParams;
  const shouldRenderVars = getShouldRenderVars({
    booleans: styleParams.booleans,
    numbers: styleParams.numbers,
    isMobile,
    isRTL,
  });

  return {
    ...getDisplayCssVars({...styleParams.booleans, ...shouldRenderVars}),
    ...getCustomCssVars(customCssVarsFnParams),
  };
};
